import { render, staticRenderFns } from "./integral-order-detail.vue?vue&type=template&id=2cedc017&scoped=true&"
import script from "./integral-order-detail.vue?vue&type=script&lang=js&"
export * from "./integral-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./integral-order-detail.vue?vue&type=style&index=0&id=2cedc017&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cedc017",
  null
  
)

export default component.exports